const gridClass = (key) => `MuiDataGrid-${key}`;
export const classes = [
    gridClass("cell"),
    gridClass("cellCheckbox"),
    gridClass("columnHeaders"),
    gridClass("columnHeader"),
    gridClass("columnHeaderCheckbox"),
    gridClass("columnHeaderDraggableContainer"),
    gridClass("columnHeaderTitleContainer"),
    gridClass("columnHeadersInner"),
    gridClass("columnsPanel"),
    gridClass("menuIcon"),
    gridClass("virtualScroller"),
    gridClass("pinnedColumnHeaders--left"),
    gridClass("pinnedColumnHeaders--right"),
    gridClass("root--densityCompact"),
    gridClass("root--densityStandard"),
    gridClass("root--densityComfortable"),
    gridClass("columnSeparator--resizable"),
];
//# sourceMappingURL=dataGrid.classes.js.map